<template lang="pug">
div.pad
  div.marginTop
  p.labelDivider
    | Dados do cônjuge
  div.tittle
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required|cpf", v-slot="{ errors }", :name="nomeAba + '/Conjuge - CPF'")
        app-label(label="CPF:")
        el-input.input(
          name='CPF',
          v-model="pessoa.cpf",
          v-mask="'###.###.###-##'",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="16")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Conjuge - Nome'")
        app-label(label="Nome:")
        el-input.input(
          name='Nome',
          v-model="pessoa.nome",
          maxlength="300"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'pessoa','nome')"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(v-if="isProcessoFisico" :gutter="30")
    el-col.inputDiv(v-if="isProcessoFisico" :span="8")
      validation-provider(v-slot="{ errors }", :name="nomeAba + '/Conjuge/Tipo de documento'")
        app-label(label="Tipo de documento:", :required="false")
        el-select.input(
          class="select",
          name='Tipo de documento'
          v-model="pessoa.tipoDocumento",
          value-key="codigo"
          no-match-text="Nenhum tipo de documento não encontrado",
          placeholder="Selecione",
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="(item, index) in tipoDocumentos",
            :key="index",
            :label="item",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(v-if="pessoa.tipoDocumento == 'OUTROS'" :span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Conjuge/OutrosTipoDocumento'")
        app-label(label="Outros:", :required="true")
        el-input.input(
          name='Outros',
          maxlength="30",
          v-model="pessoa.outrosTipoDocumento",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'pessoa','outrosTipoDocumento')"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(v-if="!isViuvo" :gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="!isProcessoFisico ? 'required': ''", v-slot="{ errors }", :name="nomeAba + '/Conjuge - RG'")
        app-label(label="RG:" :required="!isProcessoFisico")
        el-input.input(
          name='RG',
          maxlength="30"
          v-model="pessoa.rg",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'pessoa','rg')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="!isProcessoFisico ? 'required': ''", v-slot="{ errors }", :name="nomeAba + '/Conjuge - Órgão Expedidor'")
        app-label(label="Órgão expedidor:" :required="!isProcessoFisico")
        el-select.input(
          name='Órgão expedidor'
          class="select",
          no-match-text="Nenhum orgão encontrado",
          placeholder="Selecione",
          v-model="pessoa.orgaoExpedidor.nome"
          @change="setOrgaoCodigo"
          value-key="id"
          filterable,
          clearable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="orgaoExpedidor in orgaosExpedidores",
            :key="orgaoExpedidor.id",
            :label="orgaoExpedidor.nome",
            :value="orgaoExpedidor.nome"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="!isProcessoFisico ? 'required': ''", v-slot="{ errors }", :name="nomeAba + '/Conjuge - UF do RG'")
        app-label(label="UF do RG:" :required="!isProcessoFisico")
        el-select.input(
          name='UF do RG'
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="pessoa.orgaoExpedidor.estado"
          clearable,
          filterable,
          :disabled="!pessoa.orgaoExpedidor.nome",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="estado in estadosBr",
            :key="estado.codigo",
            :label="estado.nome",
            :value="estado.codigo"
          )
        span.help.erro {{ errors[0] }}
  slot(name = "slotContato")
  el-row.labelDiv(v-if="!isViuvo && !isProcessoFisico" :gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Conjuge - Nacionalidade'")
        app-label(label="Nacionalidade:")
        el-select.input(
          name='Nacionalidade'
          class="select",
          no-match-text="Nenhuma nacionalidade encontrada",
          placeholder="Selecione",
          v-model="pessoa.nacionalidade"
          value-key="id"
          clearable,
          filterable,
          @change='changeNacionalidade',
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in gentilico",
            :key="item.id",
            :label="item.gentilico +' - '+ item.nomePais",
            :value="item.sigla",
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="ufAndMunicipioRequired()", v-slot="{ errors }", :name="nomeAba + '/Conjuge - UF de Naturalidade'")
        app-label(label="UF de naturalidade:", :required="isBrasileiro")
        el-select.input(
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="pessoa.ufNaturalidade",
          clearable,
          @change='setMunicipioUf',
          filterable,
          :disabled="!isBrasileiro",
          name="UF de Naturalidade",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in estadosBr",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="ufAndMunicipioRequired()", v-slot="{ errors }", :name="nomeAba + '/Conjuge - Município de Naturalidade'")
        app-label(label="Município de naturalidade:", :required="isBrasileiro")
        el-select.input(
          class="select",
          name='Município de Naturalidade'
          no-match-text="Nenhum município encontrado",
          placeholder="Selecione",
          v-model="pessoa.naturalidade",
          filterable,
          :disabled="!isBrasileiro",
          :class="{'erro' : errors.length}",
          value-key="id"
        )
          el-option(
            v-for="item in municipios",
            :key="item.nome",
            :label="item.nome",
            :value="item"
          )
  el-row(v-if="!isViuvo && !isProcessoFisico" :gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Conjuge - Data de nascimento'")
        app-label(label="Data de nascimento:", :required = "true")
        el-date-picker.input.full-width(
          type="date",
          name='Data de nascimento'
          v-model="pessoa.dataNascimento",
          v-mask="'##/##/#####'",
          placeholder="Selecione",
          format="dd/MM/yyyy",
          :picker-options="pickerOptions",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row(v-if="isViuvo" :gutter="30")
    el-col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }"  :name="nomeAba + '/Conjuge - Possui certidão de óbito'")
        app-label(label="Possui certidão de óbito? ", :required="true")
        el-radio-group.radio-group(
          name="Cônjuge possui certidão?",
          v-model="pessoa.possuiCertidaoObito",
          :class="{'erro' : errors[0]}"
        )
          el-radio.radio(:label='true') Sim
          el-radio.radio(:label='false') Não
        span.help.erro {{ errors[0] }}
</template>
<script>
import { mapActions } from 'vuex'

import AppLabel from '@/components/AppLabel'
import estadosBr from '@/constants/estados'
import gentilico from '@/constants/gentilico'
const { tipoDocumentos } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {
  components: {
    AppLabel
  },

  props: {
    pessoa: {
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    isViuvo: {
      type: Boolean,
      required: true
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    },
    estadoCivil: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      oldEstadoCod: '',
      orgaosExpedidores: [],
      estadosBr,
      gentilico,
      tipoDocumentos,
      municipios: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  mounted () {
    this.setOrgaosExpeditores()
  },

  computed: {
    isBrasileiro () {
      return this.pessoa.nacionalidade && this.pessoa.nacionalidade === 'BR'
    }
  },
  methods: {
    ...mapActions({
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()
      if (this.isProcessoFisico) {
        this.orgaosExpedidores.forEach(element => {
          element.nome = element.nome.toUpperCase()
        })
      }
    },

    async setMunicipioUf (sigla) {
      this.pessoa.naturalidade = null
      this.municipios = await this.getMunicipiosByUf(sigla)
    },

    changeNacionalidade () {
      if (this.pessoa.nacionalidade && this.pessoa.nacionalidade.sigla !== 'BR') {
        this.pessoa.ufNaturalidade = null
        this.pessoa.municipio = null
      }
      if (!this.isBrasileiro) {
        this.naturalidadeCod = ''
        this.naturalidade = ''
      }
    },

    ufAndMunicipioRequired () {
      return this.pessoa.nacionalidade && !this.isProcessoFisico && this.pessoa.nacionalidade.sigla === 'BR' ? 'required' : ''
    },

    setOrgaoCodigo () {
      this.pessoa.orgaoExpedidor.codigo = this.orgaosExpedidores.find(
        orgao => orgao.nome === this.pessoa.orgaoExpedidor.nome
      ).codigo
    },
    toUppercase (valor, primeiro, segundo) {
      if (this.isProcessoFisico) {
        this[primeiro][segundo] = valor.toUpperCase()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.select {
  width: 100%;
}
.labelDivider {
  font-size: 1em;
  margin-top: 25px;
  margin-bottom: 5px;
  font-weight: 600;
}
.marginTop {
  margin-top: 15px;
}
.tittle {
  border: 1px solid #dfe4ed;
  margin-bottom: 15px;
  font-weight: 700;
}
.full-width {
  width: 100%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppDadosConjuge.vue